import { combineReducers } from "redux";
import { configureStore } from "@reduxjs/toolkit";

const noopReducer = (state = {}) => state;

export const rootReducer = combineReducers({  
  noop: noopReducer, // Placeholder reducer to avoid errors 
});
export type RootState = ReturnType<typeof rootReducer>;

const store = configureStore({
  reducer: rootReducer,
});

export default store;